import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError } from "../../types";
import { EditSurveyNameDto } from "../../types/surveys";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

type Variables = {
  guid: string;
  name: string;
  modifiedByUserId: string;
};

const useEditSurveyNameRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function editSurveyNameRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();

    const body: EditSurveyNameDto = {
      name: variables.name,
      modifiedByUserId: variables.modifiedByUserId,
    };

    const response = await fetch(`${configuration.apiRootUrl}/surveys/${variables.guid}/name`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "put",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { editSurveyNameRequest };
};

const useEditSurveyName = () => {
  const { editSurveyNameRequest } = useEditSurveyNameRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editSurveyNameRequest,
    onSuccess: async (_data, variables) => {
      await queryClient.refetchQueries(queryKeys.surveys.getSurvey(variables.guid));
    },
  });
};

export { useEditSurveyName };
